import {connect} from 'react-redux';
import {DesignChapter} from '@learningblocks/storybook-components';

import {getComponentProps, getOptionsList} from './ExperimentStep.selector';

function mapStateToProps(state, ownProps) {
  return {
    ...getComponentProps(state, ownProps),
    optionsList: getOptionsList(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const ExperimentStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.ExperimentStep);
